import KnowledgeCard from "../components/KnowledgeCard";

export default function KnowledgeBank() {
  const articles = [
    {
      title: "GST Filing Due Dates",
      description: "Important GST filing deadlines for businesses."
    },
    {
      title: "Company Law Updates",
      description: "Latest updates in Companies Act and compliance."
    },
    {
      title: "Annual Filing Guide",
      description: "Step by step guide for ROC annual filing."
    }
  ];

  return (
    <div>

      <h1>Knowledge Bank</h1>

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>

        {articles.map((article, index) => (
          <KnowledgeCard
            key={index}
            title={article.title}
            description={article.description}
          />
        ))}

      </div>

    </div>
  );
}